var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.adminPermission && _vm.userDataLoaded)?_c('div',{attrs:{"id":"admin-home"}},[(_vm.activeViewAdmin === 'Snapshot')?_c('AdminSnapshot'):_vm._e(),(_vm.activeViewAdmin != 'Snapshot')?_c('AdminTableContainer'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }